<template>
  <div class="main common_bg">
    <h2 class="title">版本更新</h2>
    <div class="content">
      <figure>
        <img src="../../../assets/img/common/logo.png">
        <figcaption>{{newVersion?`当前版本v${version}`:`已是最新版本v${version}`}}</figcaption>
      </figure>
      <button class="cursor" v-if="newVersion" @click="reStart">立即更新</button>
    </div>
    <Back @goBack="goBack"/>
  </div>
</template>
<script>
import common from "common";
import Back from "@/components/basic/back.vue";
import { mapState } from "vuex";
if (LIMI_ENV === "electron") {
  var ipc = window.require("electron").ipcRenderer;
}
export default {
  data() {
    return {
      version: common.version
    };
  },
  computed: {
    ...mapState(["newVersion"])
  },
  components: {
    Back
  },
  mounted() {
    this.$root.eventHub.$emit("updateVersion",1);
  },
  methods: {
    goBack() {
      this.$router.push("/userinfo");
    },
    reStart() {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventUpdateNow",
        data: {}
      });
      common.set('fromUpdate',1);
      common.set("promptUpdate", true);
      ipc.send("restartApp");
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .title {
    width: 100%;
    height: 75px;
    line-height: 90px;
    font-size: 26px;
    color: #fff;
    margin-bottom: 15px;
  }
  .content {
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 156px;
    img {
      height: 106px;
      width: 106px;
    }
    figcaption {
      color: #0a556b;
      font-size: 20px;
      margin-top: 15px;
    }
    button {
      height: 68px;
      line-height: 68px;
      width: 230px;
      background: #009eed;
      border-radius: 12px;
      font-size: 26px;
      color: #fff;
      margin-top: 50px;
      &:hover {
        background: #0095e1;
        color: #b5d1d9;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/updatecheck/updatecheck.vue